<template>
    <div>
        <b-loading :active="loading"></b-loading>
        <div class="section">
            <h1 class="title is-uppercase">{{ __('strings.user.roles.form.title') }}</h1>
        </div>

        <div class="section">
            <b-message v-if="sended.msg"  v-bind:type="sended.type" has-icon>
                <p v-text="sended.msg"></p>
            </b-message>
            <b-message v-if="errors.name" type="is-danger" has-icon>
                <p v-text="errors.name"></p>
            </b-message>
        </div>

        <div id="source-form" class="section">
            <div class="columns">
                <div class="column">
                    <b-field :label="__('strings.user.roles.form.name')"
                             label-position="on-border"
                             :type="{ 'is-danger': errors.name }"
                             :message="errors.name">
                        <b-input :placeholder="__('strings.user.roles.form.name')"
                                 type="name" name="name" v-bind:disabled="isDisabled"
                                 v-model="input.name" @focus="clearError"></b-input>
                    </b-field>
                </div>
                <div class="column is-2">
                    <div class="buttons is-right">
                        <b-button tag="button" type="is-success" class="is-uppercase"  @click.prevent="submit"
                                  :label="__('strings.user.roles.form.submitButton')" icon-left="content-save"/>
                    </div>
                </div>
            </div>


            <h4 class="subtitle is-4" v-if="Object.keys(this.permissions).length > 0" style="margin-top: 30px;"
                v-text="__('strings.user.permissions.title')"></h4>

            <div class="columns is-multiline" v-if="Object.keys(this.permissions).length > 0">
                <div class="column is-4" v-for="(entity, index) in this.permissions"
                     :key="entity.entity_type+'_'+index">
                    <strong>{{ucFirst(entity.entity_type)}}</strong>
                    <table class="table is-narrow is-fullwidth" v-if="entity.name.length > 0">
                        <tr v-for="(action, index) in entity.name.split(', ')">
                            <td align="left" :key="entity.entity_type +'_' + action + '_' + index"
                                v-text="ucFirst(action)">
                            </td>
                            <td class="has-text-weight-bold" align="right">
                                <b-switch v-model="input[entity.entity_type][action]"
                                          :name="entity.entity_type +'_' + action"></b-switch>
                            </td>
                        </tr>
                    </table>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            loading: true,
            input: {
                name: ""
            },
            errors: {
                name: "",
            },
            sended: {
                roleMessage: {
                    msg: '',
                    type: ''
                },
                permissionMessage: {
                    msg: '',
                    type: ''
                }
            },
            item: null,
            isDisabled: false,
            permissions: {},
            enabledPermissions: {}
        };
    },
    mounted() {
        if (this.$route.params.action === "create") {
            axios.get('/roles/getPermissions')
                .then(response => {
                    this.permissions = response.data;
                    this.mapPermissions();
                });
        }
        if (this.$route.params.hasOwnProperty('routeKey') && this.$route.params.routeKey) {
            axios.get('/roles/edit/' + this.$route.params.routeKey)
            .then(response => {
                this.item = response.data;
                this.input = response.data;
                this.isDisabled = true;
                this.permissions = Object.assign({}, response.data.permissions);
                this.enabledPermissions = Object.assign({}, response.data.enabledPermissions);
                this.mapPermissions();
            })
        }
    },
    methods: {
        submit() {
            let method = this.item ? 'patch' : 'post';
            let url = this.item ? `/update/roles/${this.$route.params.routeKey}` : '/store/roles';
            axios({method, url, data: this.input})
                .then(response => {
                    this.sended = response.data;
                    this.loading = false;
                })
                .catch(error => {
                    this.errors.name = error.response.data.errors.name[0];
                    this.loading = false;
                });
        },
        clearError(event) {
            this.errors[event.target.name] = "";
        },
        mapPermissions() {
            var enabledCapabilities = {};
            var enabledValues = {};
            for (const [key, permissionObject] of Object.entries(this.enabledPermissions)) {
                enabledCapabilities[permissionObject.entity_type] = permissionObject.name.split(', ');
            }
            for (const [key, permissionObject] of Object.entries(this.permissions)) {
                var capabilities = permissionObject.name.split(', ');
                var tmpObj = {};
                var entity = permissionObject.entity_type;
                if (enabledCapabilities.hasOwnProperty(entity)) {
                    enabledValues[entity] = enabledCapabilities[entity];
                }

                for (let capability of capabilities) {
                    if (enabledValues.hasOwnProperty(entity)) {
                        tmpObj[capability] = enabledValues[entity].includes(capability);
                    }else{
                        tmpObj[capability] = false;
                    }
                }

                this.$set(this.input, permissionObject.entity_type, tmpObj);
                this.loading = false;
            }
        },

    }
};
</script>
